import { ICreateProfileRequest, IUpdateProfileResponse } from "./user-create.interface";

import { CREATE_PROFILE } from "./user-create.mutation";
import { EVER_HAD_APPOINTMENT_QUERY } from "../appointment-exist/appointment-exist.query";
import { mapToProfileCreateRequest } from "./user-create.mapper";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useFetchUserDetailLazy } from "../user-detail/user-detail.service";
import { useModal } from "../../context/ModalContext";
import { useMutation } from "@apollo/client";
import { useUserCreateStore } from "../../hooks/redux-hooks/user-create-store/user-create.store";
import { userActions } from "../../state/user";

export const useProfileCreateV2 = () => {
  const dispatch = useDispatch();
  const { closeModal }=useModal();
  const { createProfile: profile } = useUserCreateStore();
  const fetchUserDetail = useFetchUserDetailLazy();
  const [create, { data, loading, error }] = useMutation<{ updateProfileV2: IUpdateProfileResponse }>(CREATE_PROFILE, {
    onCompleted: async () => {
      await fetchUserDetail();
      dispatch(userActions.setCreateProfile(null));
      closeModal();
    },
    onError: (mutationError) => {
    // Defining onError marks the failure as handled so the mutate promise
    // resolves instead of rejecting (avoids an unhandled promise rejection).
    // The user toast is raised by the global Apollo errorLink and the error
    // is also exposed via the returned `error` state.
    },
  });

  const createProfile = (data:any) => {
    if (!profile) return;

    const profileRequest: ICreateProfileRequest = mapToProfileCreateRequest(data);

    create({
      variables: { data: profileRequest },
      refetchQueries: [
        { query: EVER_HAD_APPOINTMENT_QUERY },
      ],
    });
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  return {
    createProfile,
    data,
    error,
    loading,
  };
};
